import LessonPlansSection from './LessonPlansSection';

export default LessonPlansSection;
